module.exports = __webpack_public_path__ + "static/media/hand-to-ear.73933617.png";